export default __webpack_public_path__ + "static/media/che.51c1c883.svg";